import { useRef } from 'react';
import { CircularListProps as Props } from '../../../../../shared/types/props/list';
import List from '../list';

const MAX_ITERATIONS = 15;
const ITEM_AMOUNT_TO_LOOP = 2;
const ITEMS_ON_SCREEN = 3;

function CircularList(props: Props) {
  const childrenRef = useRef(props.children);
  childrenRef.current = props.children;

  const onChange = (newIndex: number, increment?: number) => {
    if (increment === 0) return;

    const originalChildrenAmount = props.originalChildren?.current.length || 0;

    if (
      increment === -1 &&
      newIndex % originalChildrenAmount === originalChildrenAmount - 1
    ) {
      if (props.focus && props.outOfBounds && props.setListIndex) {
        props.outOfBounds(props.focus, 'LEFT');
        setTimeout(() => props.setListIndex?.current(newIndex + 1, 0));
      }
      return;
    }

    // Circular list functionality

    if (props?.onChange) props.onChange(newIndex, increment);

    if (
      childrenRef.current?.length &&
      newIndex >= childrenRef.current.length - ITEMS_ON_SCREEN
    ) {
      props.updateItems(childrenRef.current.length);
    }

    if (newIndex > originalChildrenAmount * MAX_ITERATIONS) {
      props.resetList();
    }
  };

  return (
    <List
      {...props}
      onChange={
        (props.originalChildren?.current.length || 0) > ITEM_AMOUNT_TO_LOOP
          ? onChange
          : props.onChange
      }
    ></List>
  );
}

export default CircularList;
